export class DashboardPermissions {
    public static readonly view: string = 'ui:view:dashboards';
    public static readonly readCase: string = 'metrics:read:case';
    public static readonly readClaim: string = 'metrics:read:claim';
}
